import { defineMessages } from 'react-intl';

export default defineMessages({
  orderInTheKitchenMsg: {
    defaultMessage: 'Your order is in the kitchen',
  },
});
